import { render, staticRenderFns } from "./append-box.vue?vue&type=template&id=1df3e236&scoped=true"
import script from "./append-box.vue?vue&type=script&lang=ts"
export * from "./append-box.vue?vue&type=script&lang=ts"
import style1 from "./append-box.vue?vue&type=style&index=1&id=1df3e236&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df3e236",
  null
  
)

export default component.exports